export interface Role {
  id: number;
  name: string;
  description?: string;
  created_at?: string;
  updated_at?: string;
}

export interface UserGetDTO {
  id: number;
  email: string;
  role?: Role | Role[] | string | string[] | null;
  name?: string | null;
  is_active: boolean;
  is_blocked: boolean;
  is_deleted: boolean;
}

export interface PaginatedUsersResponse {
  data: UserGetDTO[];
  total: number;
  limit: number;
  page: number;
}

export interface UserDTO {
  name: string;
  email: string;
  password: string;
  first_name?: string;
  last_name?: string;
}

export interface UserUpdateDTO {
  email: string;
  role?: number | number[] | string | string[];
  name?: string;
  password?: string;
  is_active?: boolean;
  is_blocked?: boolean;
  is_deleted?: boolean;
}

// Agregar tipos para el filtro
export type UserStatus = 'all' | 'active' | 'inactive' | 'block' | 'pending';

export interface StatusOption {
  label: string;
  value: UserStatus;
  icon?: string;
}

// Agregar tipos para roles
export type UserRole = 'admin' | 'editor' | 'reader';

export interface RoleOption {
  label: string;
  value: string;
}
